import React from "react";
import { Form } from "react-bootstrap";

class TextField extends React.Component {
  validateAndChange = (e, fieldName, callback) => {
    let isValid = true;

    const {
      isNumber = false,
      isEmail = false,
      isTextOnly = false,
      isDecimal = false,
      isAlphaNumeric = false,
      isSpecialAlphaNumeric = false,
      isUrl = false,
      isZipcode=false
    } = this.props;

    /* Replace HTML tag characters */
    // let re = new RegExp(/^><|<|>|<\/|\/|\//gim);
    // let inputVal = e.target.value.replace(re, "");
    // e.target.value = inputVal;

    if (isNumber && e.target.value !== "") {
      let isNum = /^\d+$/.test(e.target.value);
      if (!isNum) {
        isValid = false;
      }
    }

    if (isDecimal && e.target.value !== "") {
      //let isNum = /^[+-]?\d+(\.\d+)?$/.test(e.target.value);
      let isNum = /^\d*\.?\d*$/.test(e.target.value);
      //let isNum = !isNaN(e.target.value);
      if (!isNum) {
        isValid = false;
      }
    }

    if (isTextOnly && e.target.value !== "") {
      let isText = /^[A-Za-z]( ?[A-Za-z] ?)*$/.test(e.target.value);
      if (!isText) {
        isValid = false;
      }
    }

    if (isAlphaNumeric && e.target.value !== "") {
      let isAlphaNumeric = /^(?=.*[a-zA-Z0-9])( ?[A-Za-z0-9] ?)+$/.test(e.target.value);
      ///^[0-9a-zA-Z]( ?[0-9a-zA-Z] ?)*$/.test(e.target.value);
      if (!isAlphaNumeric) {
        isValid = false;
      }
    }

    if (isSpecialAlphaNumeric && e.target.value !== "") {
      let isSpecialAlphaNumeric =
        /^(?=.*[a-zA-Z])( ?[A-Za-z0-9 , . ! $ % & - ( )] ?)+$/.test(e.target.value);
      if (!isSpecialAlphaNumeric) {
        isValid = false;
      }
    }

    if (isUrl && e.target.value !== "") {
      let isUrl = /^(?!https?:\/\/).*$/.test(e.target.value);
      ///^[0-9a-zA-Z]( ?[0-9a-zA-Z] ?)*$/.test(e.target.value);
      //console.log("isurl...",isUrl)
      if (!isUrl) {
        isValid = false;
      }
    }
    if (isZipcode && e.target.value !== "") {
      let isZipcode = /^[0-9 \-]+$/.test(e.target.value);
      ///^[0-9a-zA-Z]( ?[0-9a-zA-Z] ?)*$/.test(e.target.value);
      //console.log("isurl...",isUrl)
      if (!isZipcode) {
        isValid = false;
      }
    }
    if (isEmail) {
      let isEmail = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        e.target.value
      );
      if (!isEmail) {
        isValid = false;
      }
    }

    if (isValid) {
      callback(e, fieldName);
    }
  };

  onBlurChange = (e, fieldName, callback) => {
    let isValid = true;

    if (isValid) {
      callback(e, fieldName);
    }
  };

  renderComponent = () => {
    const {
      type="text",
      name,
      action,
      onBlurAction,
      value,
      placeholder,
      required,
      readOnly=false,
      maxLength=50,
      className,
      isInvalid,
      style
    } = this.props;
      return (
        <div>
        { name !== "zipCode" ? 
          <div>
          <Form.Control 
          type={type} 
          placeholder={placeholder}
          autoComplete="off"
          name = {name} 
          value={value} 
          onChange={e => this.validateAndChange(e, name, action)} 
          required={required}
          readOnly={readOnly}
          maxLength={maxLength}
          className={className}
          isInvalid={isInvalid}
          style={style}
          />
        </div>
        :
        <div>
          <Form.Control 
          type={type} 
          placeholder={placeholder}
          autoComplete="off"
          name = {name} 
          value={value} 
          onChange={e => this.validateAndChange(e, name, action)} 
          onBlur={e => this.onBlurChange(e, name, onBlurAction)}
          required={required}
          readOnly={readOnly}
          className={className}
          style={style}
          />
        </div>
        }
        
        </div>
      );
  };

  render() {
    return this.renderComponent();
  }
}
export default TextField;
